import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});



// دالة لجلب جميع طلبات العرض التجريبي
export const getAllDemoRequests = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/all/demo/requests?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// دالة لقبول النسخة التجريبية
export const acceptDemoRequest = (id, startDemo, endDemo) => {
  const token = localStorage.getItem("authToken");
  console.log("Accepting demo request with ID:", id, "Start Date:", startDemo, "End Date:", endDemo); // Debugging log
  const formData = new FormData();
  formData.append("start_demo", startDemo);
  formData.append("end_demo", endDemo);

  return api.post(`accept/demo/${id}?api_password=${API_PASSWORD}`, formData, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};


export const createDemoRequest = (payload) => {
  const token = localStorage.getItem("authToken");
  const url = `demo/request?api_password=${API_PASSWORD}`;

  // نستخدم FormData لأن السيرفر يعتمد multipart/form-data
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });

  return api.post(url, formData, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "Content-Type": "multipart/form-data",
    },
  });
};


// ❌ رفض طلب النسخة التجريبية
export const rejectDemoRequest = (id) => {
  const token = localStorage.getItem("authToken");
  return axios.get(
    `${API_BASE_URL}reject/demo/request/${id}?api_password=${API_PASSWORD}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
};

// دالة لإيقاف النسخة التجريبية
export const stopDemoRequest = (tenantId) => {
  const token = localStorage.getItem("authToken");
  return api.get(
    `stop/demo/${tenantId}?api_password=${API_PASSWORD}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
};

